import { EventEmitter } from 'events';

const popupEmitter = new EventEmitter();

export const showPopupMessage = (message, type = 'info', stayVisible = false, errorDetailsMessage = null) => {
    const config = {
        message,
        severity: type,
        autoHideDuration: stayVisible ? null : 5000,
        stayVisible,
        errorDetailsMessage,
    };

    popupEmitter.emit('popupMessage', config);
};

export default popupEmitter;
